import { apiInterceptor } from 'utils/apiInterceptor';
const speakerEndPoints = {
    getSpeakersList: async (projectId, page, search,pagelimit=10) => {
        const response = await apiInterceptor(
            `${
                process.env.REACT_APP_MYXP_API
            }/manager/livestream/speakers?projectId=${projectId}&page=${page}&limit=${pagelimit}${
                search ? `&search=${search}` : ''
            }`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    },
    getFilteredSpeakersList: async (projectId, speakers) => {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/filtered?projectId=${projectId}&speakers=${speakers}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    },
    createSpeaker: async (projectId, speakerData) => {
        speakerData.append('projectId', projectId);

        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers`,
            {
                method: 'POST',
                headers: {
                },
                body: speakerData,
            }
        );
        return await response.json();
    },
    updateSpeaker: async (projectId, speakerData, speakerId) => {
        speakerData.append('projectId', projectId);

        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/${speakerId}`,
            {
                method: 'POST',
                headers: {
                },
                body: speakerData,
            }
        );
        return await response.json();
    },
    getSpeakerDetails: async (projectId, speakerId) => {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/${speakerId}?projectId=${projectId}`,
            {
                method: 'GET',
                headers: {
                },
            }
        );
        return await response.json();
    },
    deleteSpeaker: async (projectId, speakerId) => {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/${speakerId}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ projectId: projectId }),
            }
        );
        return await response.json();
    },
};

export default speakerEndPoints;
